import get from "lodash/get";

import graphqlToUserModel from "shared/util/graphqlToUserModel";
import getImageResizerPath from "shared/util/getImageResizerPath";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

/**
 * Convert various types of user data encountered in quickmatch into the
 * standard user model data format.
 * @param {Object} data - the user data
 * @return {Object} a converted user data
 */
export const prepUserData = (data) => {
	if (data.__typename && data.__typename === "StackMatch") {
		return graphqlToUserModel({
			...data.match,
			__stream: data.stream,
		});
	} else if (data.__typename && data.__typename === "Match") {
		return graphqlToUserModel(data);
	} else if (data.data) {
		return data.data;
	} else {
		return data;
	}
};

/**
 * Get data ready for the similar users component, taking either pubexpress or
 * graphql formatted data.
 * @param {Array} data - similar users
 * @return {Array} - the prepped users
 */
export const prepSimilarUsers = (data) => {
	if (!data || !Array.isArray(data)) {
		return [];
	}

	return data.map((i) => {
		if (i.__typename) {
			return i;
		} else {
			const imagePath = i.thumbnail_filepath.split("/").length === 4
				? `0x0/225x225/${i.thumbnail_filepath}`
				: i.thumbnail_filepath;

			return {
				user: {
					id: i.userid,
					primaryImage: {
						square225: `${getImageResizerPath()}/${imagePath}`,
					},
				},
			};
		}
	});
};

/**
 * Assemble a dictionary of stack user guides.
 * @param {Object} data - data returned from the okapi call
 * @param {Array} userGuides - a list of user guide names
 * @return {Object} - a dictionary of stack names to booleans
 */
export const getStackTooltipUserGuides = (data, userGuides) => {
	const hasSeenUserGuides = get(data, "user.hasSeenUserGuides") || [];
	const res = {};

	userGuides.forEach((userGuide, i) => {
		res[userGuide.replace(/^STACK_/, "")] = !!hasSeenUserGuides[i];
	});

	return res;
};

export function formatStacksExpirationTime(expirationTimestamp) {
	const expirationDiffFromTodayInMs = expirationTimestamp - Date.now();
	const daysUntilExpiration = Math.round(expirationDiffFromTodayInMs / ONE_DAY_IN_MS);
	return daysUntilExpiration - 1;
}



// WEBPACK FOOTER //
// ./src/apps/quickmatch/util/helpers.js